import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useRealtyStore } from '../../../../stores/realty-store';
import { useId } from 'react';
import {
  formatRealtyFilterNumber,
  KOSICEREAL_REALTY_FILTER_RECIPE,
  type RealtyFilterTemplateSetting,
} from '../realty-filter-recipe';
import styles from '../realty-filter.module.css';
import { RealtyFilterRange } from './utils/realty-filter-range';

type RealtyFilterPriceProps = {
  templateSetting?: RealtyFilterTemplateSetting;
};

export const RealtyFilterPrice = ({ templateSetting }: RealtyFilterPriceProps) => {
  const { t } = useTranslations();
  const { setFilter, filter } = useRealtyStore();
  const instanceId = useId();
  const headingId = `${instanceId}-realty-filter-price-heading`;
  const currency = useGlobalStore(state => state.generalLayout.currency);
  const { min, max, step } = KOSICEREAL_REALTY_FILTER_RECIPE.price;
  const heading = t('text340');
  const formatPrice = (price: number) =>
    `${formatRealtyFilterNumber(price)}${currency ? ` ${currency}` : ''}`;

  if (templateSetting && !templateSetting.enabled) {
    return null;
  }

  return (
    <div className={styles.fieldGroup} style={{ order: templateSetting?.order }}>
      <section className={styles.section} aria-labelledby={headingId}>
        <h2 id={headingId} className={styles.heading}>
          {heading}
        </h2>
        <RealtyFilterRange
          ariaLabel={heading}
          bounds={[min, max]}
          rangeLabels={[t('text1427'), t('text86')]}
          unboundedLabel={t('text4019')}
          step={step}
          value={[filter.price_from, filter.price_to]}
          formatAccessibleValue={formatPrice}
          renderValue={formatPrice}
          onCommit={([from, to], [, effectiveMaximum]) =>
            setFilter({
              price_from: from,
              price_to: to === effectiveMaximum ? undefined : to,
            })
          }
        />
      </section>
      <Separator className={styles.separator} />
    </div>
  );
};
